import { createAction } from 'Lib/reduxUtils';
import { milliseconds as perfTimer } from 'Lib/utils/perfTimer';

import {
  ADD_SESSION_ACTIVITY_TYPES,
  APP_SESSION_STARTED,
  SESSION_ACTIVITY,
  SESSION_TIMEOUT,
  USER_SESSION_STARTED,
} from './constants';

export const addSessionActivityTypes = createAction(
  ADD_SESSION_ACTIVITY_TYPES,
  (actionTypes: string[]) => ({
    actionTypes,
  })
);

export const appSessionStarted = createAction(
  APP_SESSION_STARTED,
  (sessionId: string | null, time: number = Date.now(), perfTime: number = perfTimer()) => ({
    sessionId,
    time,
    perfTime,
  })
);

export const userSessionStarted = createAction(
  USER_SESSION_STARTED,
  (sessionId: string | null, time: number = Date.now(), perfTime: number = perfTimer()) => ({
    sessionId,
    time,
    perfTime,
  })
);

export const sessionActivity = createAction(
  SESSION_ACTIVITY,
  (time: number = Date.now(), type: string | null = null, perfTime: number = perfTimer()) => ({
    time,
    type,
    perfTime,
  })
);

export const sessionTimeout = createAction(SESSION_TIMEOUT, (time: number = Date.now()) => ({
  time,
}));
